module.exports = __webpack_public_path__ + "static/bg-d8925d45a577e200d8f056e6c13eb30d.png";